import { useRouter } from 'next/router';

import { customizationFindStepByUrl } from '@/utils/customizationUtils';
import { CUSTOMIZATION_STEPS } from '@/constants/customization';

export const useCustomizationParams = () => {
  const router = useRouter();
  const { id, step, options } = router.query;

  return {
    id,
    step: customizationFindStepByUrl(CUSTOMIZATION_STEPS, step),
    options: Object.fromEntries(new URLSearchParams(options))
  };
};
